import { Component, forwardRef, Input } from '@angular/core';
import { ControlValueAccessor, FormGroup, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-dropdown-search-single-select',
  templateUrl: './dropdown-search-single-select.component.html',
  styleUrl: './dropdown-search-single-select.component.scss',
  standalone: false,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => DropdownSearchSingleSelectComponent),
      multi: true
    }
  ]
})
export class DropdownSearchSingleSelectComponent implements ControlValueAccessor {
  @Input() data: any[];
  @Input() formGroup: FormGroup;
  @Input() label: string;
  @Input() nullLabel: string;
  @Input() placeholder: string;
  @Input() emptyPlaceholder: string;
  @Input() searchPlaceholder: string;
  @Input() subscriptSizing: string;
  @Input() attribute: string;
  @Input() formControlName: string;

  private onChange: (value: any) => void;
  private onTouched: () => void;
  private value: any;

  writeValue(value: any): void {
    this.value = value;
  }

  registerOnChange(fn: (value: any) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }
}
